/**
 * Height of a toolbar's text controls: the table search field and the
 * date-range picker sit side by side in many toolbars and must be the same
 * height, so both read this.
 */
export const TOOLBAR_CONTROL_HEIGHT = '3rem';
